import { useTranslation } from 'react-i18next';
import { LogOut } from 'lucide-react';
import { MainLayout } from '@/components/layout/MainLayout';
import { PageHeader } from '@/components/layout/PageHeader';
import { AvatarUploadCard } from '@/components/prestadores/AvatarUploadCard';
import { DadosPessoaisCard } from '@/components/perfil/DadosPessoaisCard';
import { useAuthContext } from '@/contexts/AuthContext';

export default function MeuPerfil() {
  const { t } = useTranslation();
  const { signOut } = useAuthContext();

  return (
    <MainLayout>
      <div className="p-6 flex flex-col gap-5">
        <PageHeader titulo={t('myProfile.title')} />
        <AvatarUploadCard />
        <DadosPessoaisCard />
        <button
          type="button"
          onClick={() => signOut()}
          className="ow-btn ow-btn--ghost text-destructive self-center"
        >
          <LogOut className="h-4 w-4 mr-2" />
          {t('nav.logout')}
        </button>
      </div>
    </MainLayout>
  );
}
